import { type User } from '@kalos/kalos-rpc';

// Department id for Sales and the trade id (Residential HVAC) it maps onto. Mirrors the
// hardcoded remap baked into the `dispatchable_techs` view so bookkeeping can keep Sales
// techs in the Sales department without dropping them off the Residential HVAC board.
const SALES_DEPARTMENT_ID = 53;
const RESIDENTIAL_HVAC_TRADE_ID = 20;

/**
 * Resolves the dispatch trade code for a user, mirroring `dispatchable_techs.department_code`:
 * prefer the explicit `employee_trade_id`, otherwise fall back to the bookkeeping department
 * (with the Sales -> Residential HVAC remap). Keep this in sync with the view definition.
 */
export const resolveEmployeeTradeCode = (
  user: Pick<User, 'employeeTradeId' | 'employeeDepartmentID'>,
): number => {
  if (user.employeeTradeId) {
    return user.employeeTradeId;
  }
  if (user.employeeDepartmentID === SALES_DEPARTMENT_ID) {
    return RESIDENTIAL_HVAC_TRADE_ID;
  }
  return user.employeeDepartmentID || 0;
};
